import { useId } from 'react';

/**
 * CheckAnimatedIcon — Ícone de checkmark animado padrão do Joshua.
 *
 * Uso: envolva com um elemento que tenha a classe `checkmark-animated`
 * para ativar a animação no hover (draw-in com whip elástico).
 *
 * Exemplo:
 *   <button className="btn-add checkmark-animated" onClick={onApply}>
 *     <CheckAnimatedIcon size={15} />
 *     <span className="btn-text">Aplicar</span>
 *   </button>
 */
export default function CheckAnimatedIcon({ size = 15, startColor = '#60a5fa', endColor = '#154680' }) {
  const id = useId();
  const gid = `checkmarkG${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <defs>
        <linearGradient id={gid} gradientUnits="userSpaceOnUse" x1="4" y1="12" x2="20" y2="6">
          <stop offset="0%" stopColor={startColor} />
          <stop offset="100%" stopColor={endColor} />
        </linearGradient>
      </defs>
      <g className="checkmark-stroke" stroke={`url(#${gid})`}>
        <path d="M20 6 9 17l-5-5"/>
      </g>
    </svg>
  );
}
